export default "__VITE_ASSET__16d01165__"